import { injectable } from 'inversify'

import { IDataModelTypeStrategy } from '../../../types/IDataModelTypeStrategy'

@injectable()
export class UserDataModelTypeStrategy implements IDataModelTypeStrategy {
  public readonly baseUrl = '/users'
  canEditColumns: boolean
}
